export const
  getCssVar = val => getComputedStyle(document.body).getPropertyValue(val)
